(function () {
  window.addEventListener("DOMContentLoaded", openFirstScreen);

  function openFirstScreen() {
    changeScreenWithIndex(window.wwaScreens[0].index);
    window.removeEventListener("DOMContentLoaded", openFirstScreen);
  }

  const contentContainer = document.querySelector(".wwa--content");
  const navContainer = document.querySelector(".wwa--nav");
  window.wwaScreens.forEach((item, i) => {
    const screen = window.wwaScreens[i];
    const navItem = getNavItem(screen);
    navContainer.appendChild(navItem);
  });

  insertNavItemDividers();

  let activeIndex = null;
  let isAnimating = false;

  async function changeScreenWithIndex(i) {
    if (isAnimating) return;
    isAnimating = true;

    const idx = i.target ? i.target.dataset?.index : i;
    if (!idx) throw new Error("can not find index");
    if (activeIndex === idx) return;

    activeIndex = idx;
    await handleScreenChange(idx);
  }

  async function handleScreenChange(idx) {
    const targetElement = document.querySelector(
      `div[data-screen-index='${idx}']`
    );
    const cloned = targetElement.cloneNode(true);
    const currentScreen = contentContainer.querySelector(
      "div[data-screen-state='current']"
    );
    const swiperElement = cloned.querySelector(".swiper");

    if (swiperElement && typeof Swiper === "undefined") {
      await loadSwiperScriptStyle();
      initSwiper(swiperElement);
    }

    addDynamicEventListeners(cloned);
    contentContainer.classList.add("prevent-scroll");

    if (currentScreen) {
      currentScreen.classList.add("exit");
      currentScreen.classList.remove("enter");
    }

    cloned.dataset.screenState = "current";
    contentContainer.appendChild(cloned);
    cloned.classList.add("enter");

    const computedStyle = window.getComputedStyle(cloned);
    const animationDuration =
      parseFloat(computedStyle.animationDuration) * 1000;

    highlightActiveNavItem(idx);
    cloned.classList.add("active");

    setTimeout(() => {
      contentContainer.classList.remove("prevent-scroll");
      currentScreen?.remove();
      isAnimating = false;
    }, Math.max(animationDuration - 150, animationDuration));
  }

  function highlightActiveNavItem(index) {
    const screen = window.wwaScreens.find(
      (item) => item.index === Number(index)
    );
    if (!screen) return;
    let targetNavItem = null;
    const navItems = document.querySelectorAll(".wwa--nav-item");
    navItems.forEach((navItem) => {
      if (navItem.innerText === screen.title) targetNavItem = navItem;
    });
    if (!targetNavItem) return;
    const currentActiveItem = document
      .querySelector(".wwa--nav-item.active")
      ?.classList.remove("active");
    targetNavItem.classList.add("active");
  }

  function getNavItem({ title, index, isSubsection }) {
    const div = document.createElement("div");
    div.onclick = () => {
      changeScreenWithIndex(index);
    };
    div.classList.add("wwa--nav-item");
    if (isSubsection) div.classList.add("wwa--sub-nav-item", "invisible");

    div.innerText = title;
    div.dataset.index = index;
    return div;
  }

  function insertNavItemDividers() {
    const navItems = document.querySelectorAll(".wwa--nav-item");
    for (let i = 0; i < navItems.length - 1; i++) {
      const current = navItems[i];
      const next = navItems[i + 1];

      if (
        !current.classList.contains("wwa--sub-nav-item") &&
        next.classList.contains("wwa--sub-nav-item")
      ) {
        const div = document.createElement("div");
        div.className = "wwa--expander";
        div.onclick = onClick;
        current.parentNode.insertBefore(div, next);
      }
    }

    function onClick() {
      let nextElement = this.nextElementSibling;
      this.classList.toggle("expanded");

      const subNavItems = [];

      while (
        nextElement &&
        nextElement.classList.contains("wwa--sub-nav-item")
      ) {
        subNavItems.push(nextElement);
        nextElement = nextElement.nextElementSibling;
      }

      subNavItems.forEach((item) => {
        item.classList.toggle("invisible");
      });
    }
  }

  async function loadSwiperScriptStyle() {
    return new Promise((resolve, reject) => {
      const wwaElement = document.querySelector(".wwa");
      const scriptUrl = wwaElement?.dataset.swiperScript;
      const cssUrl = wwaElement?.dataset.swiperCss;
      if (!scriptUrl) {
        return reject(
          new Error(
            `Failed to load script: no .wwa element with data-swiper-script attribute`
          )
        );
      }

      const script = document.createElement("script");
      const link = document.createElement("link");

      let scriptLoaded = false;
      let cssLoaded = false;

      const checkIfBothLoaded = () => {
        if (scriptLoaded && cssLoaded) {
          waitForScriptEvaluation()
            .then(() => resolve({ script, link }))
            .catch(reject);
        }
      };

      script.type = "text/javascript";
      script.src = scriptUrl;
      script.onload = () => {
        scriptLoaded = true;
        checkIfBothLoaded();
      };
      script.onerror = () =>
        reject(new Error(`Failed to load script: ${scriptUrl}`));
      document.body.appendChild(script);

      if (cssUrl) {
        link.rel = "stylesheet";
        link.href = cssUrl;
        link.onload = () => {
          cssLoaded = true;
          checkIfBothLoaded();
        };
        link.onerror = () => reject(new Error(`Failed to load CSS: ${cssUrl}`));
        document.head.appendChild(link);
      } else {
        cssLoaded = true;
        checkIfBothLoaded();
      }
    });
  }

  function waitForScriptEvaluation() {
    return new Promise((resolve, reject) => {
      const checkInterval = 50;
      const timeout = 5000;
      const startTime = Date.now();

      const checkCondition = () => {
        if (typeof Swiper !== "undefined") {
          resolve();
        } else if (Date.now() - startTime > timeout) {
          reject(new Error("Script evaluation timed out"));
        } else {
          setTimeout(checkCondition, checkInterval);
        }
      };

      checkCondition();
    });
  }

  function initSwiper(swiperElement) {
    const swiperType = swiperElement.dataset.swiperType;
    const swiperOptions = swiperElement.dataset.swiperOptions;
    new Swiper(swiperElement, JSON.parse(swiperOptions) || {});
  }

  function addDynamicEventListeners(node) {
    const videoHandles = node.querySelectorAll(".wwa--video-slider--handle");
    videoHandles?.forEach((handle) => {
      handle.addEventListener("click", changeVideo);
    });

    const operationHandles = node.querySelectorAll(
      "[data-role='operation-item']"
    );
    operationHandles.forEach((handle) =>
      handle.addEventListener("mouseenter", handleOperationMouseHover)
    );
  }

  function changeVideo() {
    const screen = this.closest("[data-wwa-screen]");
    const videoUrl = this.dataset.videoSrc;
    const videoDisplayDescription = screen.querySelector(
      ".wwa-video-slider--active-description p"
    );

    const nextDescription = this.querySelector("p");
    const videoElement = screen.querySelector(".wwa-video-slider--video");
    if (videoDisplayDescription.innerText === nextDescription.innerText) return;
    const wwaWrapper = document.querySelector(".wwa--wrapper");
    if (wwaWrapper) {
      wwaWrapper.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    videoElement.src = videoUrl;
    videoDisplayDescription.innerText = nextDescription.innerText;
  }

  function handleOperationMouseHover() {
    const button = this.parentElement.querySelector(".operation-link");
    const { title, url } = this.dataset;
    const computedStyle = window.getComputedStyle(button);
    const transitionDuration = computedStyle.transitionDuration;
    const durationInMs = parseFloat(transitionDuration) * 1000;
    const isOpened = button.classList.contains("opened");
    if (isOpened) {
      button.classList.toggle("opened");
      setTimeout(() => {
        changeButtonContent();
        button.classList.toggle("opened");
      }, durationInMs);
    } else {
      button.classList.toggle("opened");
      changeButtonContent();
    }

    function changeButtonContent() {
      button.innerText = "GO TO " + title.toUpperCase();
      button.href = ""; // ADDED BY OMER
      button.href = url;
    }
  }

  // console.log(window.wwaScreens);
})();
